export default __webpack_public_path__ + "98fef9607e60a0a2176c991b4191564f.png";